import { periodFormat } from 'utils/common';

export const createReqBody = (filter, customerId) => {
  return {
    filters: {
      customerId: customerId,
      search: filter.search ? filter.search : '*',
      requesterRole: filter.requesterRole[0] ? filter.requesterRole : '*',
      ticketStatus: filter.ticketStatus[0] ? filter.ticketStatus : '*',
      priority: filter.priority[0] ? filter.priority : '*',
      assigneeName: filter.assigneeName[0] ? filter.assigneeName : '*',
      createdAt: periodFormat(filter.createdAt),
      lastUpdatedAt: periodFormat(filter.lastUpdatedAt)
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
